export default "__VITE_ASSET__8b372fb9__"